import { DepositInfo, TDeposit } from '../../../shared/api/contract';

export function depositFormat(deposit: DepositInfo): TDeposit {
    return {
        depositedAmount: Number(deposit.depositedAmount) / 1000000000000000000,
        weight: Number(deposit.weight) / 1000000000000000000,
        accumulator: Number(deposit.accumulator),
        lastRewardDeposit: Number(deposit.lastRewardDeposit),
        lockEnds: Number(deposit.lockEnds),
        rewards: [],
        reward: 0,
        index: 0n
    };
}
